import { render, staticRenderFns } from "./BIDashboard.vue?vue&type=template&id=c59bd2fe"
import script from "./BIDashboard.vue?vue&type=script&lang=js"
export * from "./BIDashboard.vue?vue&type=script&lang=js"
import style0 from "./BIDashboard.vue?vue&type=style&index=0&id=c59bd2fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports